import { useMemo } from 'react';

import CurrencySign from 'components/price/CurrencySign.component';
import { useGilt, useTranslation } from 'providers/GILT.provider';
import isFullArray from 'utils/predicates/array/isFullArray.util';

export const CheckoutTaxes = ({ taxes, fees }) => {
  const { isSalonInUS } = useGilt();
  const { t } = useTranslation();

  const hasTaxesAndFees = isFullArray(taxes) || isFullArray(fees);

  const groupedTaxes = useMemo(() => {
    const groupedTaxesMap = {};

    if (isFullArray(taxes)) {
      taxes.forEach((tax) => {
        if (!groupedTaxesMap[tax.id]) {
          groupedTaxesMap[tax.id] = { ...tax };
        } else {
          groupedTaxesMap[tax.id].flatAmount = (groupedTaxesMap[tax.id].flatAmount || 0) + (tax.flatAmount || 0);
          groupedTaxesMap[tax.id].percentageAmount = (groupedTaxesMap[tax.id].percentageAmount || 0) + (tax.percentageAmount || 0);
        }
      });
    }

    return Object.values(groupedTaxesMap);
  }, [taxes]);

  const groupedFees = useMemo(() => {
    const groupedFeesMap = {};

    if (isFullArray(fees)) {
      fees.forEach((fee) => {
        if (!groupedFeesMap[fee.id]) {
          groupedFeesMap[fee.id] = { ...fee };
        } else {
          groupedFeesMap[fee.id].flatAmount = (groupedFeesMap[fee.id].flatAmount || 0) + (fee.flatAmount || 0);
          groupedFeesMap[fee.id].percentageAmount = (groupedFeesMap[fee.id].percentageAmount || 0) + (fee.percentageAmount || 0);
        }
      });
    }

    return Object.values(groupedFeesMap);
  }, [fees]);

  if (!isSalonInUS || !hasTaxesAndFees) return null;

  return (
    <div data-bem="CheckoutTaxes" className="table-checkout service">
      <div className="thead gray">
        <div className="cell-product cell-full">{t('checkout.checkoutTaxes.title')}</div>
        <div className="cell-total">{t('checkout.checkoutTaxes.total')}</div>
        <div className="cell-last" />
      </div>
      <div className="tbody">
        {groupedTaxes.map((tax) => (
          <div key={tax.id} className="tr">
            <div className="cell-product cell-full">{tax.name}</div>
            <div className="cell-total">
              <CurrencySign value={tax.flatAmount ? tax.flatAmount : tax.percentageAmount} />
            </div>
            <div className="cell-last" />
          </div>
        ))}
        {groupedFees.map((fee) => (
          <div key={fee.id} className="tr">
            <div className="cell-product cell-full">{fee.name}</div>
            <div className="cell-total">
              <CurrencySign value={fee.flatAmount ? fee.flatAmount : fee.percentageAmount} />
            </div>
            <div className="cell-last" />
          </div>
        ))}
      </div>
    </div>
  );
};
